import React from 'react';
// <strong> tag fixes issue with visited link color on mso
export function LinkWrapper(props) {
    var children = props.children, fontWeight = props.fontWeight, _a = props.isRtl, isRtl = _a === void 0 ? false : _a;
    return (React.createElement("strong", { style: { fontWeight: fontWeight || 'normal' }, dir: isRtl ? 'rtl' : undefined }, children));
}
//# sourceMappingURL=link-wrapper.js.map